import { Stack } from '@mui/material';
import Typography from '../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import EmailAutocomplete from './EmailAutocomplete/EmailAutocomplete';

interface OrderPaymentEmailContentProps {
  emails: string[];
  onChangeEmails: (emails: string[]) => void;
  customerId?: string;
}

const OrderPaymentEmailContent = ({
  customerId,
  emails,
  onChangeEmails,
}: OrderPaymentEmailContentProps) => {
  const { translate } = useTranslation();

  return (
    <Stack spacing={2}>
      <Typography color="text.secondary">
        {translate(LangEnum.PAYMENT_LINK_ENTER_EMAILS)}
      </Typography>
      <EmailAutocomplete customerId={customerId} emails={emails} onChangeEmails={onChangeEmails} />
    </Stack>
  );
};

export default OrderPaymentEmailContent;
